import React, { PropTypes as p } from 'react'
import moment from 'moment'

import { DataCard, DarkBlueBadge, Badge } from '../data-card/data-card-parts'

import PinPreview from './pin-preview'

const PinList = ({
  pins,
  onPinClick,
  onPinMouseOver,
  onPinMouseOut,
  activePinId,
  ...rest
}) => (
  <div className='pin-list' {...rest}>
    {pins.map(pin =>
      <PinPreview key={pin.id}
        pin={pin}
        area={pin.area}
        active={activePinId === pin.id}
        onClick={() => onPinClick(pin.id)}
        onMouseOver={() => onPinMouseOver(pin.id)}
        onMouseOut={() => onPinMouseOut(pin.id)}
      />
    )}

    {!pins.length &&
      (<p className='no-content'>No pins found.</p>)}
  </div>
)

PinList.propTypes = {
  pins: p.array.isRequired,
  onPinClick: p.func
}

export default PinList



// WEBPACK FOOTER //
// ./src/components/pins/pin-list.js